import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div className="container centered">
      <h2>Page Not Found</h2>
      <p className="mb-4">The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn">Go Home</Link>
    </div>
  );
}

export default NotFoundPage;